import axios from 'axios';
import store from '@/store/index.js';

const axiosInstance = axios.create({
    baseURL: "https://crm.monartisan.ci/backend/api/v1/",
    withCredentials : false,
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "POST"
    // headers : {
    //     Authorization : `Bearer ${store.state.token}`
    // }
})

export default {
    install: (app, options) => {
        app.config.globalProperties.$axios = { ...axiosInstance }
    }
}